/**
 * Atalho da paleta "Ir para…": ⌘K no Mac, Ctrl K nos outros. Só o atalho
 * que aparece no botão abre a paleta (no Mac, Ctrl K segue sendo do campo de
 * texto).
 */
type NavigatorLike = {platform?: string; userAgent?: string};

export const isMacPlatform = (
  nav: NavigatorLike | undefined = navigatorLike()
) =>
  /Mac|iPhone|iPad|iPod/i.test(
    `${nav?.platform || ''} ${nav?.userAgent || ''}`
  );

function navigatorLike(): NavigatorLike | undefined {
  return typeof navigator === 'undefined' ? undefined : navigator;
}

export const shortcutLabel = (mac: boolean) => (mac ? '⌘K' : 'Ctrl K');

export const shortcutAria = (mac: boolean) => (mac ? 'Meta+K' : 'Control+K');

export const isPaletteShortcut = (
  event: Pick<
    KeyboardEvent,
    'key' | 'metaKey' | 'ctrlKey' | 'altKey' | 'shiftKey'
  >,
  mac: boolean
) => {
  if ((event.key || '').toLowerCase() !== 'k') return false;
  if (event.altKey || event.shiftKey) return false;
  return mac
    ? event.metaKey && !event.ctrlKey
    : event.ctrlKey && !event.metaKey;
};
